import React from 'react';
import '../../ReassignQueuePage.scss'
import HrbTranslate from '../../../../components/language/HrbTranslate';
import WorkflowStatusIcon from '../../../../components/library/workflow-tasks/WorkflowStatusIcon';
import { TaskStatus } from '../../../vdo-ticket/services/TaskStatus';
import { Close } from '@mui/icons-material';
import Button from '../../../../components/library/buttons/Button';

const ReassignErrorModal = (props) => {

    const { onClose } = props

    return (
        <div className='reassign-modal-background'>
            <div className='reassign-error-modal'>
                <div className='error-modal-header'>
                    <WorkflowStatusIcon status={TaskStatus.IN_PROGRESS} />
                    <div className='error-header-text'>
                        <h4><HrbTranslate text='ManageTicket.AssignmentError.Title' /></h4>
                    </div>
                    <div className='error-header-close'>
                        <Close onClick={() => onClose()} />
                    </div>
                </div>
                <div className='error-modal-body-wrapper'>
                    <div className='error-modal-body'>
                        <div className='error-modal-text'>
                            <p className='p2 error-text mb-2'><HrbTranslate text='ManageTicket.AssignmentError.Warning' /></p>
                            <p className='p2 mb-2'><HrbTranslate text='ManageTicket.AssignmentError.InvalidAgent' /></p>
                        </div>
                        <Button
                            elementId='assign-error-close-btn'
                            labelKey='App.Close'
                            buttonStyles='secondary'
                            onClick={() => onClose()} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReassignErrorModal